/**
 * Moved to own file so we can use these in admin2
 */

export const languages: Record<string, string> = {
  fi: 'Suomeksi',
  en: 'In English',
  se: 'På Svenska',
  fr: 'En Français',
  es: 'En Español',
  de: 'Auf Deutsch',
}

export const appLanguages: Record<string, string> = {
  fi: 'Suomeksi',
  en: 'In English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  sv: 'Svenska',
  nl: 'Nederlandse taal',
}
